import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { MetaDataHelper } from "../core/util/metaDataHelper.js";
import { Helper } from "../core/util/helper.js";
import DocumentFolderStructureTree from "../documents/documentFolderStructureTree.js";
import { ExpandOnInitState } from "../core/components/kendoTree.js";
import { DocumentFolderStructure, DocumentFolderStructureTreeVm, DocumentListItem, DocumentPreview } from "../documents/documents.js";
import React from "react";
export default class DocumentDetailsApp extends React.Component<DocumentDetailsAppProps, {
    dataLoaded: boolean,
    subCategories: SubCategoryLookUpViewModel[]
}> {
    common = new AppHelper();
    saveEnabled = true;
    documentTreeActivated: boolean = false;

    constructor(props) {
        super(props);
        this.state = {
            dataLoaded: false,
            subCategories: null
        }
        this.props.dataSources["pathsList"] = [];
        this.props.dataSources["subCategories"] = [];
        this.initApp();
        this.documentTreeActivated = this.props.documentTreeActivated;
    }

    private initApp = async () => {
        let url = "DocumentLookup/GetCategories";
        if (!this.props.entity.IsNew && Helper.hasValue(this.props.entity.Kategid)) {
            url += `?currentId=${this.props.entity.Kategid}`;
        }
        if (Helper.hasValue(this.props.type)) {
            url += `&dokumentReferenceType=${this.props.type}`
        }
        if (!Helper.isNullOrEmpty(this.props.table)) {
            url += `&table=${this.props.table}`
        }
        const data = await HTTPService.get(url);
        this.props.dataSources["docDetailsKategid"] = data;
        this.common.enableHooks = true;
        this.common.init(this);
        this.setState({ dataLoaded: true })
    }

    componentDidMount() {
        this.loadSubCategories();
    }

    private loadSubCategories = async () => {
        let data = await HTTPService.get("DocumentLookup/GetSubCategories");
        this.setState({ subCategories: data }, () => this.setSubCategoriesDataSource(this.props.entity.Kategid));
    }

    private setSubCategoriesDataSource = (kategId: number) => {
        let dataSource = [];
        if (Helper.hasValue(kategId))
            dataSource = this.state.subCategories.filter(x => x.KategId == kategId);
        this.props.dataSources.subCategories = dataSource;
    }

    renderLocatedLocallyInfo = () => {
        return (
            <div style={{ width: "100%", border: "2px solid #2F96B4", borderLeftWidth: "8px", padding: "8px", borderRadius: "4px", lineHeight: "1.1em", display: "grid", gridTemplateColumns: "auto auto" }}>
                <label>
                    {Helper.getTranslation("Dokument.NotSynchronized").replace("{name}", this.props.entity.LocatedLocallyRessource)}
                </label>
                <i className="fa-light fa-hourglass-start fa-lg" aria-hidden="true" style={{ height: "100%" }} ></i>
            </div>
        );
    }

    renderPreview = () => {
        let document = this.props.documents.find(x => x.Isguid == this.props.entity.IsGuid);
        return <DocumentPreview
            filename={document.FileName}
            dokuGuid={document.Isguid}
            additionalUrlParams={null}
            showOverflowY={false} />
    }

    save = async () => {
        if (this.common.validate(null, true)) {
            const result = await HTTPService.post<JsonResultClass>("Document/SaveDetails", {
                vm: this.props.entity,
                type: this.props.type,
                refid: this.props.refId,
                table: this.props.table
            })
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, true);
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case ("entity.Kategid"):
                MetaDataHelper.setFieldValue(this.props.entity, "entity.OnlyInternal", dataItem.OnlyInternal);
                if (dataItem.OnlyInternal)
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Nurintern", 1);
                this.props.entity.SubKategId = 0;
                this.setSubCategoriesDataSource(value);
                break;
            case ("entity.Nurintern"):
                if (this.props.entity.OnlyInternal)
                    isInit = true;
                break;
        }

        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }

    }

    private onTreeSelectionChanged = (dataItem: DocumentFolderStructure) => {
        this.handleFieldChange({ model: "entity.VirtualFolder" }, dataItem.OriginalFolder);
        this.handleFieldChange({ model: "entity.VirtualFolderTranslated" }, dataItem.TranslatedFolder);
    }

    private onTreeDataLoaded = (vm: DocumentFolderStructureTreeVm) => {
        let pathList: any[] = [];
        this.setPathsList(pathList, vm.TreeData);
        this.props.dataSources.pathsList = pathList;
        this.setState({});
    }

    private setPathsList = (pathsList: any[], items: DocumentFolderStructure[]) => {
        for (let item of items) {
            pathsList.push({ path: item.TranslatedFolder });
            this.setPathsList(pathsList, item.Children);
        }
    }

    renderFolderStructureTree = () => {
        if (!this.props.documentTreeActivated)
            return null;

        return <DocumentFolderStructureTree
            type={this.props.type}
            documents={this.props.documents}
            withDocuments={false}
            onSelectionChanged={this.onTreeSelectionChanged}
            expandOnInitState={ExpandOnInitState.AllNodes}
            onDataLoaded={this.onTreeDataLoaded} />;
    }

    render() {
        if (!this.state.dataLoaded)
            return null;
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface SubCategoryLookUpViewModel {
    Id?: number;
    KategId?: number;
    TranslatedBeschreibung?: string;
}

export interface DocumentDetailsAppProps extends AppBaseProps {
    context: DocumentDetailsContext;
    entity: DocumentDetailsEntity;
    id: string;
    type: number;
    refId: string;
    table?: string;
    documentTreeActivated?: boolean;
    documents?: DocumentListItem[];
    dataSources: {
        subCategories?: any[];
        pathsList?: any[];
    }
}

interface DocumentDetailsContext extends Context {
}

export interface DocumentDetailsEntity extends Entity {
    DokuId: number;
    Titel: string;
    Nurintern: number;
    Bemerkung: string;
    Kategid: number;
    AnlageLogIn: string;
    Verzeichnis: string;
    Dokutyp: number;
    IsHyperlink: boolean;
    OnlyInternal: boolean;

    LocatedLocallyRessource: string;
    SubKategId: number;
    VirtualFolderOriginal?: string;
    VirtualFolderTranslated?: string;
    IsGuid: string;
}